<div class="prazo-select" [class.prazo-select-disabled]="desabilitado">
  <div class="input-group input-group-sm">
    <input
      class="form-control form-control-sm"
      [ngClass]="{ 'is-invalid': invalido }"
      type="text"
      [(ngModel)]="termo"
      (focus)="abrir()"
      (input)="abrir()"
      (blur)="fecharComAtraso()"
      [disabled]="desabilitado"
      autocomplete="off"
      placeholder="Digite para filtrar ou selecione..."
    />
    <div class="input-group-append">
      <button class="btn btn-outline-secondary btn-sm prazo-select-toggle" type="button" (mousedown)="$event.preventDefault()" (click)="alternar()" [disabled]="desabilitado">
        <span aria-hidden="true">&#9662;</span>
      </button>
    </div>
  </div>

  @if (aberto && !desabilitado) {
    <div class="prazo-select-menu">
      <button class="prazo-select-opcao prazo-select-vazia" type="button" (mousedown)="$event.preventDefault()" (click)="limpar()"></button>

      @if (!ocultarTitulosIniciais && prazosIniciaisFiltrados().length > 0) {
        <div class="prazo-select-titulo">Prazos Iniciais</div>
      }

      @for (opcao of prazosIniciaisFiltrados(); track opcao.idprazopagamento) {
        <button
          class="prazo-select-opcao"
          [class.prazo-select-opcao-ativa]="prazoSelecionado != null && prazoSelecionado.idprazopagamento == opcao.idprazopagamento"
          type="button"
          (mousedown)="$event.preventDefault()"
          (click)="selecionar(opcao)"
        >
          {{ opcao.descricao }}
        </button>
      }

      @if (prazosEspeciaisFiltrados().length > 0) {
        <div class="prazo-select-titulo">Prazos Especiais</div>
      }

      @for (opcao of prazosEspeciaisFiltrados(); track opcao.idprazopagamento) {
        <button
          class="prazo-select-opcao"
          [class.prazo-select-opcao-ativa]="prazoSelecionado != null && prazoSelecionado.idprazopagamento == opcao.idprazopagamento"
          type="button"
          (mousedown)="$event.preventDefault()"
          (click)="selecionar(opcao)"
        >
          {{ opcao.descricao }}
        </button>
      }

      @if (!temResultados()) {
        <div class="prazo-select-sem-resultado">Nenhum prazo encontrado</div>
      }
    </div>
  }
</div>
